import { AlphaCIcon } from './AlphaCIcon';

/**
 * author: GreenTurtwig
 * id F5F53184-51BB-46A3-AB67-D799A1D15F7F
 * name alpha-c
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-c.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetCIcon = AlphaCIcon;
export default AlphabetCIcon